// This isn't used anymore. Left here for historical reasons.
import Flickity from 'flickity';
import googleMaps, { styles } from '../lib/googleMaps.js';

export default {
  init(components) {
    googleMaps(() => {
      const mapElement = document.getElementById('map');
      const markerData = $(mapElement).data('marker');
	  //check if the elements are there on the page
	  if(mapElement !== "undefined" && mapElement !== null &&
	  markerData !== "undefined" && markerData !== null)
	  {
		  //create the lat long to use
		  const latLng = new google.maps.LatLng(markerData.lat, markerData.lng);

		  // Init Google Maps
		  const map = new google.maps.Map(mapElement, { styles, center: latLng, zoom: 17 });

		  // Add the marker
		  new google.maps.Marker({ position: latLng, map, icon: '/dist/images/map-marker.png' });
	  }
    });
  },
}
